module.exports = __webpack_public_path__ + "21c1a555319703f4141eed496e48b86a.png";